var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-container',[(!_vm.noData)?_c('div',{style:({
      height: '500px',
      width: '100%',
    }),attrs:{"id":"RtMap"}}):_vm._e(),(_vm.noData)?_c('div',{staticStyle:{"height":"85%"}},[_c('EmptyContent')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }